
<style lang="less">
.screens-register {
  position: absolute;
  inset: 0 0 0 0;
  display: flex;
  flex-direction: column;

  .reg-body {
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .reg-body-content {
      width: 280px;
      flex: 1;
      text-align: center;

      .reg-body-section {
        transition: all 1000ms ease-in-out;
        top: 0;
        overflow: hidden;
      }

      .reg-body-heading {
        color:#fff;
        font-weight: bold;
        font-size: 1.8em;
        text-align:center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .img-wn-logo {
        display: flex;
        align-items: start;
        justify-content: center;
        position: relative;
        transition: top 300ms ease;

        .img-wn-logo-inner {
          width: 100%;
          max-width: 240px;
        }
      }

      .reg-body-btns {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
      }

      .btn-my-location, .btn-search-location {
        font-weight: bold;
        font-size: 16pt;
        text-align: center;
        background-color: #fff;
        padding: 8px 0;
        border-radius: 8px;
        display: block;
        cursor: pointer;
        transition:transform 150ms ease-in-out;
        margin-bottom: 20px;

        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>


<template>
  <div class="screens-register">
    <div class="reg-body">
      <div class="reg-body-content">
        <div class="reg-body-section reg-body-heading" :style="{ height: loc ? 0 : '30%', opacity: loc ? 0 : 1 }">
          <div style="font-size: 0.8em;">GREETINGS</div>
          <div>WEATHER NERD</div>
        </div>
        <div class="reg-body-section img-wn-logo" :style="{ height: '25%', top: loc ? '40px' : null }">
          <div class="img-wn-logo-inner">
            <wn-logo ref="refLogo" />
          </div>
        </div>
        <div class="reg-body-section reg-body-heading" :style="{ height: loc ? '35%' : 0 }">
          <div v-if="isPromo" style="font-size: 0.8em;">
            <div style="font-size: 0.8em;">
              YOU STOPPED BY ON
            </div>
            OUR FIRST DAY!?!<br /><br />
            <div style="font-size: 0.8em;">
              How about a
              <strong>free 6-month subscription</strong>
              to celebrate?
            </div>
            <div style="font-size: 0.5em; font-weight: 200;">
              (and to clear out the bugs)
            </div>
          </div>
          <div v-else style="font-size: 0.6em;">
              GREAT!<br /><br />
              NOW CHOOSE A SUBSCRIPTION...
          </div>
        </div>
        <div class="reg-body-section reg-body-btns" :style="{ height: loc ? 0 : '40%', opacity: loc ? 0 : 1 }">
          <div class="btn-my-location theme-color" @click="clickMyLocation">
            <mdi-icon icon="near_me" />
            Use My Location
          </div>
          <div class="btn-search-location theme-color" @click="clickSearch">
            <mdi-icon icon="search" />
            Search Locations
          </div>
        </div>
        <div class="reg-body-section" :style="{ height: loc ? '40%' : 0 }">
          <renewal-buttons @done="onRenewal" :isPromo="isPromo" />
        </div>
      </div>
    </div>
    <theme />
  </div>
</template>

<script setup lang="ts">
import Theme from '@/theme/theme.vue';
import MdiIcon from '@/client/mdi-icon.vue';
import { launchLocationsModal } from '@/settings/locations-modal/util';
import { clientContext } from '@/client/context';
import { computed, ref } from 'vue';
import RenewalButtons from '@/expired/renewal/renewal-buttons.vue';
import WnLogo from '@/registration/wn-logo.vue';
import { isPromo } from '@/registration/is-promo';

const loc = computed<IUserLocationSettings>(() => clientContext.settings.currentLocation);
const refLogo = ref(null);

const clickMyLocation = async () => {
  clientContext.settings.currentLocation = clientContext.settings.locations.find(l => l.id === 'live');
};

const clickSearch = async () => {
  await launchLocationsModal();
};

const onRenewal = async () => {
 console.log(`registration.onRenewal...`);
 refLogo.value.run(() => {
    clientContext.settings.registrationTime = Date.now();
  });
};

</script>
